export * from "./Color";
export * from "./Url";
export * from "./Json";
export * from "./Date";
export * from "./Number";
export * from "./Object";
export * from "./String";
export * from "./Widget";

export const getBreakpoints = (device: "tablet" | "mobile") => {
    switch (device) {
        case "mobile":
            return (
                elementorFrontend?.breakpoints?.responsiveConfig?.activeBreakpoints?.mobile
                    ?.value ?? 767
            );
        case "tablet":
            return (
                elementorFrontend?.breakpoints?.responsiveConfig?.activeBreakpoints?.tablet
                    ?.value ?? 1024
            );
    }
};
